import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
import { SparkleDecoration } from './ui/SparkleDecoration';
export function GuaranteeSection() {
  return <section className="py-20 bg-rose/20 relative overflow-hidden" data-id="element-88">
      {/* Decorative elements */}
      <div className="absolute top-10 left-10 opacity-60" data-id="element-89">
        <SparkleDecoration size={40} color="#E8735A" data-id="element-90" />
      </div>
      <div className="absolute bottom-10 right-10 opacity-60" data-id="element-91">
        <SparkleDecoration size={50} color="#6B1F2A" type="star" data-id="element-92" />
      </div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-93">
        <AnimatedSection data-id="element-94">
          <div className="text-6xl md:text-7xl mb-6" data-id="element-95">🛡️</div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-charcoal mb-6" data-id="element-96">
            Tu compra tiene cero riesgo
          </h2>
          <p className="text-lg md:text-xl text-charcoal/80 mb-8 leading-relaxed" data-id="element-97">
            Si en los próximos 7 días sentís que no era para vos, te devolvemos
            el 100% de tu dinero. Sin preguntas. Sin formularios. Sin drama.
          </p>
          <p className="text-xl font-bold text-coral" data-id="element-98">
            Así de seguros estamos de que esto va a cambiar tu vida.
          </p>
        </AnimatedSection>
      </div>
    </section>;
}